module.exports = __webpack_public_path__ + "assets/images/park-03.82faa5e7fc54ec6082d611472a4e41fa.svg";